import * as React from 'react';
import { useState, useEffect, useMemo, useRef } from 'react'; 
import { Popup } from '../../organisms'
import './styles.css';
 
export const SimpleCalendar = React.forwardRef((props, ref) => { 
  const DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const DAYS_OF_THE_WEEK = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
  const MONTHS = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
  const eventRef =  useRef()
  const today = useMemo(() => new Date(), []);
  const [date, setDate] = useState(today);
  const [day, setDay] = useState(date.getDate());
  const [month, setMonth] = useState(date.getMonth());
  const [year, setYear] = useState(date.getFullYear());
  const [dateArray, setDateArray] = React.useState([]);
  const [lastDays, setLastDays] = React.useState([]);
  const [prevDays, setPrevDays] = React.useState([]);
  const firstDay = dateArray.length > 0 && dateArray[0]
  const [isOpen, setIsOpen] = React.useState(false);
  const [title, setTitle] = React.useState({mealsRu:'Прием пищи'})
 
  //Подсчет количества дней между выбранными датами
  let quonityDay = dateArray.length === 1 ||  dateArray.length===0 ? 
  dateArray.length : dateArray.length === 2 && dateArray[1] > dateArray[0] && Math.ceil((dateArray[1]-dateArray[0]+1)/86400000)

  //создание пустого массива с количеством выбранных дат
  let arr= quonityDay> 0 ? Array.from(Array(quonityDay), () => {
    return { date: 0};
  }) : [];
 
  let dataDate = props.dateDay && arr.length ===0 ? props.dateDay : arr
  const disabledAddDish = dataDate.length === 0 || title.mealsRu === 'Прием пищи'
  const disabledCopyPlan= dataDate.length === 0
 //Заполнение массива выбранными датами в мс
  for (let i = 0; i < arr.length; i += 1) {
    arr[i].date = firstDay+i*86400000
  }
 
  //Отправка выбранных дат выше в компонент
  useEffect(() => { 
    props.onDayRange(dataDate) 
  }, [dateArray])


  useEffect(() => {
    setDay(date.getDate());
    setMonth(date.getMonth());
    setYear(date.getFullYear());
    //setStartDay(getStartDayOfMonth(date));
  }, [date]);

  function getStartDayOfMonth(date) {
    const startDate = new Date(date.getFullYear(), date.getMonth(), 7).getDay();
    return startDate
  }

  // Переход к следующему месяцу
  function nextMonth () {
    if ( month === 11 ) {
      setMonth(0);
      setYear(year+1);
    }
  else {
    setMonth(month+1)
  }
};

// Переход к предыдущему месяцу
  function previousMonth() {
  if ( month === 0 ) {
    setMonth(11)
    setYear(year - 1);
  }
  else {
    setMonth (month - 1)
  }
};
  useEffect(() => { 
    showcurr(year, month)
  }, [])
  // Показать текущий месяц
  function showcurr() {
    showMonth(year, month);
  };
  useEffect(() => {
    showMonth(year, month);
  }, [year, month]);

  function handleMealsOpen() {
    setIsOpen(!isOpen)
  }
  function handleChangeEvents(el) {
    setTitle(el)
    setIsOpen(false)
  }

// Показать месяц (год, месяц)
function showMonth(y, m) {
  const d = new Date(y, m, 7)
  // Первый день недели в выбранном месяце 
  const firstDayOfMonth = new Date(y, m, 7).getDay()
  // Последний день выбранного месяца
  const lastDateOfMonth =  new Date(y, m+1, 0).getDate()
  // Последний день предыдущего месяца
  const lastDayOfLastMonth = m == 0 ? new Date(y-1, 11, 0).getDate() : new Date(y, m, 0).getDate();

  let i=1;
  do {
    let dow = new Date(y, m, i).getDay();
     // Начать новую строку в понедельник
    if ( firstDayOfMonth === 0 ) {
      setLastDays([])
    }

    // Если первый день недели не понедельник показать последние дни предыдущего месяца
    if ( i===1 && dow !== 1 ) {
      let k = lastDayOfLastMonth - firstDayOfMonth+1;
      const lastDays =[]
      for(let j=0; j < firstDayOfMonth; j++) {
        lastDays[j] = new Date(y, m-1, k++)
      }
      setLastDays(lastDays)
    }
    // Если последний день месяца не воскресенье, показать первые дни следующего месяца
    if ( i == lastDateOfMonth ) {
      let k=1;
      let j =0
      const prevDays =[]
      for(dow; dow < 7; dow++) {
        prevDays[j++] = new Date(y, m+1, k++)
      }
      if(prevDays.length ===7) {
        setPrevDays([])
      } else {
        setPrevDays(prevDays)
      }  
    }
    i++;
  } while(i <= lastDateOfMonth);
}
   //запись в стейт выбранных дат
   function handleClick(d) {
    if (dateArray.length===1) {
      //если даты выбраны в обратном порядке пересортировка по возрастанию
      setDateArray([...dateArray, d.getTime()].sort(function(a, b) {
        return a - b;
      }))
    } else if(dateArray.length === 2  || dateArray.length === 0) {
    
      setDateArray([d.getTime()])
    }
  }
  
  //Расчет высокосный год или нет
  function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  const days = isLeapYear(year) ? DAYS_LEAP : DAYS;

  const daysArr=Array.from(Array(days[month]), (i, index) => {
    return i = new Date(year, month, index+1) 
  })
 
  const fullMonthDay =  [...lastDays, ...daysArr, ...prevDays]

  const Day = (props) => {
    const d =props.d && props.d 
    const today = props.today
    const userMenu = props.userMenu
    const isDisabled = today !== undefined && d && (today.getTime() > d.getTime())
    const selected = userMenu.length > 0 && userMenu.some((k)=> {
      return k.date === d.getTime()
    })
 
    function handleClick() {
      props.onClick(props.d)
    }
   
    return (
      <>
      {d > 0 
      ? <p onClick={handleClick} disabled={isDisabled} className={`day font14Norm ${isDisabled && !selected ?  'disabled' 
      : props.isToday && !selected && props.isSelected === undefined ? 'today'
      : props.isToday && selected && !props.isSelected ? 'today__saveDay' : props.isToday && selected && props.isSelected ? 'today selected'
      : props.isToday || props.isSelected ? 'selected' : selected ? 'saveDay' 
      : props.first === d ? 'first-selected'       // добавьте ваш стиль для первого выбранного элемента
      : props.isLastSelected ? 'last-selected' : '' }`}>{d.getDate()}</p>
      : <strong className='day font14SBold'>{props.d}</strong>
      }
     </> 
    )
  }
 
  return (
    <div ref={ref} className={`frame ${props.isOpen ? 'calendar__visibility' : ''} frame__${props.type}`}>
      <div className='calendar-header'>
        <button className='button__calendar button__calendar_left' onClick={previousMonth} />
        <div className='font14SBold colorGrey'>
          {MONTHS[month]} {year}
        </div>
        <button className='button__calendar button__calendar_right'onClick={nextMonth}/>
      </div>
      <div className='calendar__body'>
        {DAYS_OF_THE_WEEK.map((d, index) => (
          <Day key={d} d={d} i={index} userMenu={[]}/>
        ))}
        
        {fullMonthDay.map((i, index) => {
          const selected = dataDate.find((k)=> { 
            return k.date === i.getTime()
          })
          const first = dataDate[0] && dataDate[0].date
          const last = dataDate[0]  && dataDate[dataDate.length - 1].date 
         
            return (
              <Day
                key={index}
                d={i}
                i={index}
                today={today}
                isToday={i.getTime() === today.setHours(0,0,0,0)}
                isSelected={selected}
                onClick={handleClick}
                userMenu={props.userMenu}
                first={first}
                last={last}
              >
              </Day>
            );
          })}
      </div>
     {props.meals.length > 0 ?
     <>
      <div className='calendar__eating'>
        <p className='calendar__meals font14Norm colorGrey'  onClick={handleMealsOpen}>{title.mealsRu} <span className={`ingtoggle ${!isOpen ? 'gg-poligon-down' : 'gg-poligon-up'} s-12-10`}> </span> </p>
        <button disabled={disabledAddDish} className={`x-size ${disabledAddDish ? 'gg-ok-disabled' : 'gg-ok' }`}  onClick={()=> props.handleAddRecipeinMeals({title, dataDate})}></button>
      </div>
      <Popup isOpen={isOpen} ref={eventRef} type='calendar'>
        {props.meals.map((el, index) => <p className='event-text' key={index} onClick={()=> handleChangeEvents(el)}>{el.mealsRu}</p>)} 
      </Popup> 
      </>
      : props.choice === 'choice' && <button disabled={disabledCopyPlan} className={`x-size ${disabledCopyPlan ? 'gg-ok-disabled' : 'gg-ok' }`}  onClick={()=> props.handleAddRecipeinMeals(dataDate)}></button>
        }
    </div>
   
  );
})